module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/price-config-active.dd2cecd5.svg";